export default "__VITE_ASSET__CCRcjgnd__"